import React from 'react'
//import { HTML_DOC_TYPE, DOC_TYPE_GOVERNANCE } from '../../../../helpers/constants';
import store from '../../../../stores/store';
import onClickOutside from "react-onclickoutside";

let fs
let dialog
if (window.require) {
    fs = window.require('fs')
    let remote = window.require('electron').remote
    dialog = remote.dialog
}

class SaveAsButton extends React.Component {
    constructor() {
        super()
        this.state = {
            downloadDropdown: false
        }
    }

    toggleDownloadDropdown = () => {
        this.setState({
            downloadDropdown: !this.state.downloadDropdown
        })
    }

    canDownload = permissions => {
        return ((permissions & 4) === 4)
    }

    canDownloadNative = permissions => {
        return ((permissions & 32) === 32)
    }

    downloadOriginal = async () => {
        this.hideDownloadDropdown()
        const instanceId = store.companies.selectedId;
        const docTypeId = this.props.docTypeId;
        const doc = this.props.document
        const docId = doc.Id == null ? doc.AgendaDocId : doc.Id
        const DocExtension = doc.DocExtension

        const result = await store.documents.downloadNativeFormatAndDecrypt({docId, instanceId, docTypeId, DocExtension})
        
        if (fs && dialog) {
            const savedFilePath = dialog.showSaveDialog(null, { defaultPath: doc.DocName + "." + doc.DocExtension })
            if (savedFilePath != null) {
                fs.writeFile(savedFilePath, result, (err) => {
                })
            }
        }
    }

    downloadPDF = async () => {
        this.hideDownloadDropdown()
        const instanceId = store.companies.selectedId;
        const docTypeId = this.props.docTypeId;
        const doc = this.props.document
        const docId = doc.Id == null ? doc.AgendaDocId : doc.Id
        const DocExtension = doc.DocExtension
        const DocPermissions = doc.DocPermissions
        const DocName = doc.DocName

        const result = await store.documents.downloadAndDecryptDocument({
            instanceId, docTypeId, docId, DocExtension, DocPermissions, DocName
        })       

        if (fs && dialog) {
            const savedFilePath = dialog.showSaveDialog(null, { defaultPath: DocName + ".pdf" })
            if (savedFilePath != null) {
                fs.writeFile(savedFilePath, result, (err) => {
                })
            }
        }
    }

    hideDownloadDropdown = () => {
        this.setState({
            downloadDropdown: false
        })
    }

    handleClickOutside = evt => {
        this.hideDownloadDropdown()
    }

    render() {
        const document = this.props.document
        const result = ((document.DocExtension === "pdf" || document.Converted) && ((document.Converted && this.canDownloadNative(document.DocPermissions)) || this.canDownload(document.DocPermissions))) ? (
            <div><div className={ this.state.downloadDropdown ? "dropdown show" : "dropdown"}>
            <button className="btn btn-sm btn-outline-secondary border-0 ml-2 dropdown-toggle" type="button" id="dropdownMenuButton_doc" data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.downloadDropdown} onClick={() => this.toggleDownloadDropdown()}>
                <i className="fa fa-download" aria-hidden="true"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton_doc">
                { document.Converted && this.canDownloadNative(document.DocPermissions) &&
                <a className="dropdown-item m-0" onClick={() => this.downloadOriginal()} >Original document</a>}
                { this.canDownload(document.DocPermissions) && 
                <a className="dropdown-item m-0" onClick={() => this.downloadPDF()}>PDF</a>}
            </div>
        </div></div>
        ) : null
        return window.require ? result : null
    }
}

export default onClickOutside(SaveAsButton);


// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/components/SaveAsButton.js